//? Note: jurisdiction specific component

import React from 'react';
import { connect } from 'react-redux';
import { Container, Navbar } from 'react-bootstrap';
import { getCMSObject, CMSContent } from 'sg-ui-components';
import { mapStateToProps, mapDispatchToProps } from '../../../Store';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/pro-solid-svg-icons';
import Menu from '../../Menu.js';

library.add(faBars, faXmark);
dom.watch();

const Header = () => {
    return (
        <div className='page-header'>
            <header>
                <Container className='toolbar-nav'></Container>
                <LotteryNav />
                <MobileNav />
                <PrimaryNav />
            </header>
        </div>
    );
};

const LotteryLogoTemplate = ({ cmsSourceFirebase }) => {
    return (
        <div className='header-lottery-logo-container'>
            <CMSContent
                localStorageObject='webContent'
                contentPath='data.sitewideSettings.headerLogo.image'
                className='img-fluid lottery-logo-main'
                cmsSourceFirebase={cmsSourceFirebase}
            />
        </div>
    );
};
const LotteryLogo = connect(mapStateToProps, mapDispatchToProps)(LotteryLogoTemplate);

const LotterySocialIconsTemplate = ({ cmsSourceFirebase }) => {
    return (
        <ul className='social-networks'>
            <li className='social-icons'>
                <CMSContent
                    localStorageObject='webContent'
                    contentPath='data.sitewideSettings.socialIcons.facebookIcon.image'
                    className='img-fluid lottery-logo-main'
                    cmsSourceFirebase={cmsSourceFirebase}
                />
                <CMSContent
                    localStorageObject='webContent'
                    contentPath='data.sitewideSettings.socialIcons.instagramIcon.image'
                    className='img-fluid lottery-logo-main'
                    cmsSourceFirebase={cmsSourceFirebase}
                />
                <CMSContent
                    localStorageObject='webContent'
                    contentPath='data.sitewideSettings.socialIcons.xIcon.image'
                    className='img-fluid lottery-logo-main'
                    cmsSourceFirebase={cmsSourceFirebase}
                />
                <CMSContent
                    localStorageObject='webContent'
                    contentPath='data.sitewideSettings.socialIcons.youtubeIcon.image'
                    className='img-fluid lottery-logo-main'
                    cmsSourceFirebase={cmsSourceFirebase}
                />
                <CMSContent
                    localStorageObject='webContent'
                    contentPath='data.sitewideSettings.socialIcons.linkedInIcon.image'
                    className='img-fluid lottery-logo-main'
                    cmsSourceFirebase={cmsSourceFirebase}
                />
            </li>
        </ul>
    );
};
const LotterySocialIcons = connect(mapStateToProps, mapDispatchToProps)(LotterySocialIconsTemplate);

//***********************************************************************************
// Get the Toolbar Navigation via a JSON string provided by the CMS
// the Toolbar NAV is the topmost nav in the header, giving the user social media
// Links, search bars, etc.
//
const LotteryNavTemplate = ({ children }) => {
    return (
        <Navbar className='nav-lottery' collapseOnSelect expand='md'>
            <Container>
                <Navbar.Brand>
                    <LotterySocialIcons />
                    <LotteryLogo />
                    {children}
                </Navbar.Brand>
            </Container>
        </Navbar>
    );
};

const LotteryNav = connect(mapStateToProps, mapDispatchToProps)(LotteryNavTemplate);

//***********************************************************************************
// Get the Primary Navigation via a JSON string provided by the CMS
// the Primary Navigation is a series of drop-downs for MO.
//
const PrimaryNavTemplate = ({ children }) => {
    const localStoragePrimaryMenu = getCMSObject('primaryMenu', 'webMenu');

    return (
        <Navbar id='basic-navbar-nav' className='nav-primary' expand='xl'>
            <Menu menu_json={localStoragePrimaryMenu} />
            {children}
        </Navbar>
    );
};
const PrimaryNav = connect(mapStateToProps, mapDispatchToProps)(PrimaryNavTemplate);

const MobileNavTemplate = () => {
    const primaryMenu = getCMSObject('primaryMenu', 'webMenu');

    return (
        <div className='mobile-nav'>
            <Navbar className='d-flex d-md-none mobile-nav-row' expand='xs'>
                <Navbar.Brand>
                    <LotteryLogo />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls='responsive-navbar-nav'>
                    <FontAwesomeIcon icon='fa-solid fa-bars' />
                    <FontAwesomeIcon icon='fa-solid fa-xmark' />
                </Navbar.Toggle>
                <Navbar.Collapse className='ml-auto'>
                    <Menu menu_json={primaryMenu} className='primary-menu' />
                </Navbar.Collapse>
            </Navbar>
        </div>
    );
};

const MobileNav = connect(mapStateToProps, mapDispatchToProps)(MobileNavTemplate);

export { Header, PrimaryNav, MobileNav };
